// extracted by mini-css-extract-plugin
module.exports = {"containerSearch":"header_containerSearch__3iDqf","containerSearchBar":"header_containerSearchBar__2NwwV","textPresentation":"header_textPresentation__3Kl84"};